/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentTemplateDto } from '../../models/document-template-dto';

export interface AdminDocumentTemplateControllerGetDocumentById$Params {
  id: string;
}

export function adminDocumentTemplateControllerGetDocumentById(http: HttpClient, rootUrl: string, params: AdminDocumentTemplateControllerGetDocumentById$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentTemplateControllerGetDocumentById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentTemplateDto>;
    })
  );
}

adminDocumentTemplateControllerGetDocumentById.PATH = '/api/document-template-admin/{id}';
